var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.src)?_c('img',{staticClass:"bd-flag",attrs:{"src":_vm.src,"alt":_vm.codice}}):_c('span',{staticClass:"bd-code"},[_vm._v(_vm._s(String(_vm.codice || '?').toUpperCase()))])
}
var staticRenderFns = []

export { render, staticRenderFns }